import { Page } from 'components';
import { useContext } from 'react';
import {  Filters, Results } from './components';
import { customersContext } from './CustomersContext';

let Customers = () => {
    let { isLoading } = useContext(customersContext);

    return (
        <Page
            isLoading={isLoading}
            useHeader={true}
            title="Customers"
            addNewUrl="/admin/Customer/addnew"
        >
            <Filters/>
            <Results />
        </Page>
    )
}

export default Customers;